import { createChartEvent } from './hooks/useChartEvents';
/**
 * Legend hover event used for both mousein and mouseout events
 *
 * Subscribe to this event when making interactive chart changes depending on the legend hover.
 */
export const legendEvent = createChartEvent('legend');
export const tooltipEvent = createChartEvent('tooltip');